import { render } from "./crud-company.vue?vue&type=template&id=dac0de60&scoped=true&ts=true&lang=pug"
import script from "./crud-company.vue?vue&type=script&lang=ts"
export * from "./crud-company.vue?vue&type=script&lang=ts"

import "./crud-company.vue?vue&type=style&index=0&id=dac0de60&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dac0de60"]])

export default __exports__